export default {
  ada: 'ada',
  zendesk: 'zendesk',
  salesforce: 'salesforce',
}
